import React, { useContext, useState, useEffect } from 'react'
import { func } from 'prop-types'

import { ENGRAVING_PATTERNS } from 'utils/constants'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Heading from 'components/buy/Engraving/Heading'
import StepBack from 'components/buy/Engraving/StepBack'
import EngravingOption from 'components/buy/Engraving/EngravingOption'
import List from 'components/buy/Engraving/List'

const Pattern = ({ setStep }) => {
  const { engraving, setEngraving, currentView, setCurrentView } = useContext(EngravingContext)
  const [filter] = useState(ENGRAVING_PATTERNS[0].collection)

  useEffect(() => {
    setCurrentView({ ...currentView, item: 'front', step: 'pattern' })
  }, [])

  return (
    <>
      <Heading
        title="Choose the pattern you like"
        back={() => <StepBack setStep={setStep} initialstep={'initialstep'} />}
      />

      <List row={5}>
        {ENGRAVING_PATTERNS.find(p => p.collection === filter).patterns.map((pattern, idx) => (
          <EngravingOption
            key={idx}
            selected={engraving.front.pattern.value === pattern.value}
            onClick={() => {
              const upToDateEngraving = {
                ...engraving,
                front: {
                  ...engraving.front,
                  pattern: {
                    ...engraving.front.pattern,
                    value: pattern.value,
                    name: pattern.name
                  }
                }
              }

              setEngraving(upToDateEngraving)
            }}
            name={pattern.name}
            pattern={pattern.value}
            isLimitedEdition={pattern.isLimitedEdition}
          />
        ))}
      </List>
    </>
  )
}

Pattern.propTypes = {
  setStep: func.isRequired
}

export default Pattern
